import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { useState, useEffect } from 'react';

import Home from '../Pages/Home';
import AiAndData from '../Pages/AiandData';
import Engineering from '../Pages/Engineering';
import SuccessStories from '../Pages/SuccessStories';
import Careers from '../Pages/Careers';
import ContactUs from '../Pages/contactUs';
import Telcom from '../Pages/Engineering/telcom';
import FinTech from '../Pages/Engineering/fintech';
import Gaming from '../Pages/Engineering/xrandgaming';
import AboutUs from '../Pages/AboutUS';
import PrivacyPolicy from '../Pages/PrivacyPolicy';
import TermsOfService from '../Pages/TermsofService';
import Team from '../Pages/team/Team';
import Consulting from '../Pages/consulting/Consulting';

// create a simple page loader component
const PageLoader = () => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-white dark:bg-gray-900">
    <div className="h-16 w-16 animate-spin rounded-full border-t-4 border-purple-500"></div>
  </div>
);

const pageTransition = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
  transition: { duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] as const },
};

export default function AppRouter() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  // Listen to location changes
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 400); // match your animation duration
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      {loading && <PageLoader />}

      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route
            path="/"
            element={
              <motion.div {...pageTransition}>
                <Home />
              </motion.div>
            }
          />
          <Route
            path="/ai-and-data"
            element={
              <motion.div {...pageTransition}>
                <AiAndData />
              </motion.div>
            }
          />
          <Route
            path="/engineering"
            element={
              <motion.div {...pageTransition}>
                <Engineering />
              </motion.div>
            }
          />
          <Route
            path="/success-stories"
            element={
              <motion.div {...pageTransition}>
                <SuccessStories />
              </motion.div>
            }
          />
          <Route
            path="/join-us"
            element={
              <motion.div {...pageTransition}>
                <Careers />
              </motion.div>
            }
          />
          <Route
            path="/contacts"
            element={
              <motion.div {...pageTransition}>
                <ContactUs />
              </motion.div>
            }
          />
          <Route
            path="/hire-tech-team"
            element={
              <motion.div {...pageTransition}>
                <Team />
              </motion.div>
            }
          />
          <Route
            path="/consulting"
            element={
              <motion.div {...pageTransition}>
                <Consulting />
              </motion.div>
            }
          />

          <Route
            path="/engineering/telcom"
            element={
              <motion.div {...pageTransition}>
                <Telcom />
              </motion.div>
            }
          />

          <Route
            path="/engineering/fintech"
            element={
              <motion.div {...pageTransition}>
                <FinTech />
              </motion.div>
            }
          />

          <Route
            path="/engineering/gaming"
            element={
              <motion.div {...pageTransition}>
                <Gaming />
              </motion.div>
            }
          />
          <Route
            path="/about"
            element={
              <motion.div {...pageTransition}>
                <AboutUs />
              </motion.div>
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <motion.div {...pageTransition}>
                <PrivacyPolicy />
              </motion.div>
            }
          />
          <Route
            path="/terms"
            element={
              <motion.div {...pageTransition}>
                <TermsOfService />
              </motion.div>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AnimatePresence>
    </>
  );
}
